export const LINE_DATA = {
  columns: ['季度', '提交次数'],
  rows: [
    { '季度': '1/1', '提交次数': 0 },
    { '季度': '1/2', '提交次数': 1 },
    { '季度': '1/3', '提交次数': 0},
    { '季度': '1/4', '提交次数': 0},
    { '季度': '1/5', '提交次数': 50},
    { '季度': '1/6', '提交次数': 20}
  ]
}

export const LINE_DATA1 = {
  columns: ['日期', '访问用户'],
  rows: [
    { '日期': '1/1', '访问用户': 193},
      { '日期': '1/2', '访问用户': 393}
  ]
}

export const SIMPLE_LINE_DATA = {
  columns: ['日期', '访问用户', '下单用户'],
  rows: [
    ['1/1', 1393, 1093],
    ['1/2', 3530, 3230],
    ['1/3', 2923, 2623],
    ['1/4', 1723, 1423],
    ['1/5', 3792, 3492],
    ['1/6', 4593, 4293]
  ]
}



// WEBPACK FOOTER //
// ./src/pages/data/test/data.js